/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EamEfaDashboardInfo,
} from '../models/index';
import {
    EamEfaDashboardInfoFromJSON,
    EamEfaDashboardInfoToJSON,
} from '../models/index';

export interface GetEamEfaDashboardRequest {
    partnerId: string;
}

/**
 * 
 */
export class EamEfaDashboardServiceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getEamEfaDashboard without sending the request
     */
    async getEamEfaDashboardRequestOpts(requestParameters: GetEamEfaDashboardRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['partnerId'] == null) {
            throw new runtime.RequiredError(
                'partnerId',
                'Required parameter "partnerId" was null or undefined when calling getEamEfaDashboard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/eamEfaDashboard/information/{partnerId}`;
        urlPath = urlPath.replace(`{${"partnerId"}}`, encodeURIComponent(String(requestParameters['partnerId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Information for Eam Efa Dashboard integration
     */
    async getEamEfaDashboardRaw(requestParameters: GetEamEfaDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EamEfaDashboardInfo>> {
        const requestOptions = await this.getEamEfaDashboardRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EamEfaDashboardInfoFromJSON(jsonValue));
    }

    /**
     * Get Information for Eam Efa Dashboard integration
     */
    async getEamEfaDashboard(requestParameters: GetEamEfaDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EamEfaDashboardInfo> {
        const response = await this.getEamEfaDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
